import React, { useState, useEffect } from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import Table from "../../../../../../components/Table";
import Pagination from "../../../../../../components/Pagination/Pagination";
import Calender from "../../../../../../assets/svg/icons/common/Calender";
import CaretDown from "../../../../../../assets/svg/icons/common/CaretDown";
import master_card from "../../../../../../../../images/v2/master24x24.svg";
import CheckCircle from "../../../../../../assets/svg/icons/common/CheckCircle";
import MinusCircle from "../../../../../../assets/svg/icons/common/MinusCircle";
import useCommonStore from "../../../../../../stores/common";
import useMerchantStore from "../../../../../../stores/merchant";
import InterChangeTable from "./table";
import { getMerchantInterchangeData } from "../../../../../../../api";
import moment from "moment";
import Spinner from "../../../../../../components/Loaders/Spinner";

function Interchange() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const dateRange = useCommonStore((state) => state.dateRange);

  const [interchangeData, setInterchangeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const fetchInterchangeData = async () => {
    try {
      setLoading(true);
      const response = await getMerchantInterchangeData({
        mid: activeApp?.power_app_submission?.mid,
        start_date: dateRange?.startDate,
        end_date: dateRange?.endDate,
        page: currentPage,
      });
      if (response.status) {
        setInterchangeData(response.data.data);
        setPageCount(response.data.last_page);
        setTotalItems(response.data.total);
        setItemsPerPage(response.data.per_page);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInterchangeData();
  }, [currentPage, dateRange]);

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Interchange Summary</h5>
            </div>
            <div className={style.right}>
              {/* <ButtonIcon bgColor={"#EDEDF4"}>
                <Calender />
                <span>01/01/24 - 25/01/24</span>
                <CaretDown />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Filter />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon> */}
            </div>
          </header>

          <div className={style.body}>
            <InterChangeTable data={interchangeData} loading={loading} />
          </div>
          {!loading && (
            <footer className={style.footer}>
              <Pagination
                pageCount={pageCount}
                currentPage={currentPage - 1}
                onPageChange={({ selected }) => {
                  if (selected + 1 !== currentPage) {
                    setCurrentPage(selected + 1);
                  }
                }}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
              />
            </footer>
          )}
        </div>
      )}
    </>
  );
}

export default Interchange;
